import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  center: [-36.918, 37.743],
  zoom: 3,
  initialCenter: [-36.918, 37.743]
}

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setMapPosition: (state, action) => {
      state.center = action.payload.center
      state.zoom = action.payload.zoom
    },
    setMapZoom: (state, action) => {
      state.zoom = action.payload
    }
  }
})

export const { setMapPosition, setMapZoom } = mapSlice.actions

export default mapSlice.reducer
